import { checkDaysBetween } from './Helper';

const CarHelper = {
  applyFilter(filters, cars) {
    if (filters.val.length >= 1 && filters.name && filters.type) {
      let newCars;
      switch (filters.name) {
        case 'price':
        case 'mileage':
          newCars = cars.filter((item) => {
            return (
              item[filters.name] >= filters.val[0] &&
              item[filters.name] <= filters.val[1]
            );
          });
          break;
        default:
          if (filters.name == 'brand') {
            newCars = cars.filter((item) => {
              return (
                filters.val
                  .map((i) => i.toLowerCase())
                  .indexOf(item[filters.name].toLowerCase()) !== -1
              );
            });
          } else {
            newCars = cars.filter((item) => {
              return filters.val.indexOf(item[filters.name]) !== -1;
            });
          }
      }
      return newCars;
    } else {
      return cars;
    }
  },

  sortCars(sort, cars) {
    if (Object.keys(sort).length == 0 && sort.constructor === Object) {
      return cars;
    } else {
      return cars.slice().sort(function (a, b) {
        let x = getValForSorting(a, sort.attribute);
        let y = getValForSorting(b, sort.attribute);
        if (sort.highFirst) {
          return y - x;
        } else {
          return x - y;
        }
      });
    }
  },
  isTheIntervalCorrect() {
    if (localStorage.carsLastUpdatedAt) {
      let date = new Date();
      let diff = checkDaysBetween(date, localStorage.carsLastUpdatedAt);
      return diff > 4;
    } else {
      return true;
    }
  },
};

function getValForSorting(el, attribute) {
  if (el[attribute] === null) {
    return 0;
  }
  if (attribute.indexOf('Date') === -1) {
    return el[attribute];
  } else {
    return parseInt(el[attribute].slice(6, el[attribute].length - 2));
  }
}

export default CarHelper;
